// extracted by mini-css-extract-plugin
export default {"leftSpace":"TitleRow_leftSpace__cVRxA","rightSpace":"TitleRow_rightSpace__ShUgF"};